import React from 'react';
import { AlertCircle, Phone, MapPin, Clock, MessageCircle, BookOpen, ExternalLink, PlusCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const EmergencyRescue = () => {
  const animalWelfareDirectory = [
    { state: "Andhra Pradesh", url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTklz0TeBp12BP-I1ZXWzhiKz63sFuWNLRSPB0UfRsK03kPJxKgL6QXNVMplIC62gCUzWnCzoZRnBcr/pubhtml?gid=403356697&single=true" },
    { state: "Arunachal Pradesh", url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTklz0TeBp12BP-I1ZXWzhiKz63sFuWNLRSPB0UfRsK03kPJxKgL6QXNVMplIC62gCUzWnCzoZRnBcr/pubhtml?gid=1052610001&single=true" },
    { state: "Bihar", url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTklz0TeBp12BP-I1ZXWzhiKz63sFuWNLRSPB0UfRsK03kPJxKgL6QXNVMplIC62gCUzWnCzoZRnBcr/pubhtml?gid=1375113917&single=true" },
    { state: "Chandigarh", url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTklz0TeBp12BP-I1ZXWzhiKz63sFuWNLRSPB0UfRsK03kPJxKgL6QXNVMplIC62gCUzWnCzoZRnBcr/pubhtml?gid=1367946921&single=true" },
    { state: "Delhi/ NCR", url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTklz0TeBp12BP-I1ZXWzhiKz63sFuWNLRSPB0UfRsK03kPJxKgL6QXNVMplIC62gCUzWnCzoZRnBcr/pubhtml?gid=763462878&single=true" },
    { state: "Goa", url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTklz0TeBp12BP-I1ZXWzhiKz63sFuWNLRSPB0UfRsK03kPJxKgL6QXNVMplIC62gCUzWnCzoZRnBcr/pubhtml?gid=1628565137&single=true" },
    { state: "Haryana", url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTklz0TeBp12BP-I1ZXWzhiKz63sFuWNLRSPB0UfRsK03kPJxKgL6QXNVMplIC62gCUzWnCzoZRnBcr/pubhtml?gid=194569639&single=true" },
    { state: "Pune", url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTklz0TeBp12BP-I1ZXWzhiKz63sFuWNLRSPB0UfRsK03kPJxKgL6QXNVMplIC62gCUzWnCzoZRnBcr/pubhtml?gid=1365863565&single=true" },
    { state: "Karnataka", url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTklz0TeBp12BP-I1ZXWzhiKz63sFuWNLRSPB0UfRsK03kPJxKgL6QXNVMplIC62gCUzWnCzoZRnBcr/pubhtml?gid=1435621572&single=true" },
    { state: "Kerala", url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTklz0TeBp12BP-I1ZXWzhiKz63sFuWNLRSPB0UfRsK03kPJxKgL6QXNVMplIC62gCUzWnCzoZRnBcr/pubhtml?gid=1188832597&single=true" },
    { state: "Mumbai", url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTklz0TeBp12BP-I1ZXWzhiKz63sFuWNLRSPB0UfRsK03kPJxKgL6QXNVMplIC62gCUzWnCzoZRnBcr/pubhtml?gid=576060338&single=true" },
    { state: "Rajasthan", url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTklz0TeBp12BP-I1ZXWzhiKz63sFuWNLRSPB0UfRsK03kPJxKgL6QXNVMplIC62gCUzWnCzoZRnBcr/pubhtml?gid=192137757&single=true" },
    { state: "Tamil Nadu", url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTklz0TeBp12BP-I1ZXWzhiKz63sFuWNLRSPB0UfRsK03kPJxKgL6QXNVMplIC62gCUzWnCzoZRnBcr/pubhtml?gid=1767116698&single=true" },
    { state: "Telangana", url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTklz0TeBp12BP-I1ZXWzhiKz63sFuWNLRSPB0UfRsK03kPJxKgL6QXNVMplIC62gCUzWnCzoZRnBcr/pubhtml?gid=505521948&single=true" },
    { state: "Miscellaneous", url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTklz0TeBp12BP-I1ZXWzhiKz63sFuWNLRSPB0UfRsK03kPJxKgL6QXNVMplIC62gCUzWnCzoZRnBcr/pubhtml?gid=403281047&single=true" }
  ];

  const emergencySteps = [
    {
      step: 1,
      title: 'Stay Calm',
      description: 'Approach the animal slowly and calmly. Avoid sudden movements that might frighten them.'
    },
    {
      step: 2,
      title: 'Assess the Situation',
      description: 'Check if the animal is conscious, breathing, and the severity of injuries from a safe distance.'
    },
    {
      step: 3,
      title: 'Secure the Area',
      description: 'If on a road, try to slow down traffic. Use hazard markers if available.'
    },
    {
      step: 4,
      title: 'Contact Us Immediately',
      description: 'Call our emergency helpline or send a WhatsApp message with location and photos.'
    },
    {
      step: 5,
      title: 'Do Not Move (Unless Critical)',
      description: 'Unless the animal is in immediate danger, wait for our trained team. Moving them incorrectly can worsen injuries.'
    },
    {
      step: 6,
      title: 'Provide Water',
      description: 'If conscious, you can offer water in a shallow container. Do not force feed.'
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Emergency Banner */}
      <section className="py-12 bg-safety-red text-white">
        <div className="container mx-auto px-4 text-center">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <AlertCircle className="w-12 h-12 animate-pulse" />
            <h1 className="text-4xl md:text-5xl font-bold font-heading">
              Emergency Animal Rescue
            </h1>
          </div>
          <p className="text-xl mb-6">24/7 Emergency Response Team Available</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:+919315982650">
              <Button size="lg" className="bg-white text-safety-red hover:bg-gray-100 text-lg px-8 py-6">
                <Phone className="mr-2 w-5 h-5" />
                Call: +91 9315982650
              </Button>
            </a>
            <a href="https://wa.me/919315982650?text=Emergency%20Animal%20Rescue%20Needed" target="_blank" rel="noopener noreferrer">
              <Button size="lg" variant="outline" className="border-2 border-white text-white hover:bg-white hover:text-safety-red text-lg px-8 py-6">
                <MessageCircle className="mr-2 w-5 h-5" />
                WhatsApp Emergency
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* Quick Contact Cards */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold font-heading text-forest-green mb-4">
              Contact Us Immediately
            </h2>
            <p className="text-xl text-gray-700">Choose the fastest way to reach us</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* Call Card */}
            <Card className="border-none shadow-2xl hover:shadow-3xl transition-shadow duration-300">
              <CardContent className="p-8 text-center">
                <div className="w-20 h-20 bg-safety-red rounded-full flex items-center justify-center mx-auto mb-6">
                  <Phone className="w-10 h-10 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-forest-green mb-4">Call Us</h3>
                <p className="text-gray-600 mb-6">For immediate assistance, call our 24/7 helpline</p>
                <a href="tel:+919315982650" className="block">
                  <p className="text-4xl font-bold text-safety-red mb-4">+91 9315982650</p>
                  <Button size="lg" className="w-full bg-safety-red hover:bg-red-600 text-white">
                    <Phone className="mr-2 w-5 h-5" />
                    Call Now
                  </Button>
                </a>
              </CardContent>
            </Card>

            {/* WhatsApp Card */}
            <Card className="border-none shadow-2xl hover:shadow-3xl transition-shadow duration-300">
              <CardContent className="p-8 text-center">
                <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <MessageCircle className="w-10 h-10 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-forest-green mb-4">WhatsApp Us</h3>
                <p className="text-gray-600 mb-6">Send photos & location for faster response</p>
                <a href="https://wa.me/919315982650?text=Emergency%20Animal%20Rescue%20Needed" target="_blank" rel="noopener noreferrer" className="block">
                  <p className="text-4xl font-bold text-green-500 mb-4">+91 9315982650</p>
                  <Button size="lg" className="w-full bg-green-500 hover:bg-green-600 text-white">
                    <MessageCircle className="mr-2 w-5 h-5" />
                    WhatsApp Now
                  </Button>
                </a>
              </CardContent>
            </Card>
          </div>

          <div className="mt-12 text-center">
            <p className="text-gray-600 text-lg">
              📍 Send us your location and photos of the animal for faster assistance
            </p>
          </div>
        </div>
      </section>

      {/* What to Do */}
      <section className="py-20 bg-sand-beige">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold font-heading text-forest-green mb-4">
              What To Do If You See An Injured Animal
            </h2>
            <p className="text-xl text-gray-700">Follow these steps while our team is on the way</p>
          </div>

          <div className="max-w-4xl mx-auto space-y-6">
            {emergencySteps.map((item) => (
              <Card key={item.step} className="border-none shadow-lg bg-white">
                <CardContent className="p-6">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-warm-amber text-white rounded-full flex items-center justify-center font-bold text-xl flex-shrink-0">
                      {item.step}
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-forest-green mb-2">{item.title}</h3>
                      <p className="text-gray-700">{item.description}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Animal Welfare Directory Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <BookOpen className="w-10 h-10 text-forest-green" />
              <h2 className="text-4xl font-bold font-heading text-forest-green">
                Animal Welfare Directory
              </h2>
            </div>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-2">
              We're crafting a state-by-state Animal Welfare Directory to bridge the gap between those who care and those who need care.
            </p>
            <p className="text-lg text-gray-600">
              Click your State/City for details on ambulances, vets, shelters, and more 👇
            </p>
          </div>

          {/* Directory Grid */}
          <div className="max-w-6xl mx-auto mb-12">
            <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-4">
              {animalWelfareDirectory.map((location) => (
                <a
                  key={location.state}
                  href={location.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group"
                >
                  <Card className="border-2 border-forest-green/20 hover:border-forest-green hover:shadow-lg transition-all duration-300 h-full">
                    <CardContent className="p-6 text-center">
                      <div className="flex items-center justify-center space-x-2">
                        <span className="text-lg font-semibold text-forest-green group-hover:text-warm-amber transition-colors">
                          {location.state}
                        </span>
                        <ExternalLink className="w-4 h-4 text-gray-400 group-hover:text-warm-amber transition-colors" />
                      </div>
                    </CardContent>
                  </Card>
                </a>
              ))}
            </div>
          </div>

          {/* Help Us Grow Section */}
          <div className="max-w-6xl mx-auto">
            <Card className="border-none shadow-2xl bg-gradient-to-r from-forest-green to-forest-green/90 text-white">
              <CardContent className="p-8">
                <div className="text-center mb-6">
                  <PlusCircle className="w-12 h-12 mx-auto mb-4" />
                  <h3 className="text-2xl font-bold font-heading mb-2">
                    Help Us Strengthen the Network!
                  </h3>
                  <p className="text-lg mb-6">
                    Your contribution will empower strays and their guardians across India.
                  </p>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSeQYbCuPTO4IkR_j_HACu5e0i30M-rdqXVK3UPdf1MpuDvsqw/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button size="lg" className="bg-warm-amber hover:bg-warm-amber/90 text-forest-green font-bold">
                      <PlusCircle className="mr-2 w-5 h-5" />
                      Share Local Resources
                    </Button>
                  </a>
                  <span className="text-white/80 text-sm">
                    Add ambulances, vets, shelters & more
                  </span>
                </div>

                {/* Additional Resources */}
                <div className="mt-8 pt-6 border-t border-white/20">
                  <p className="text-sm text-white/90 mb-3 text-center font-semibold">Additional Resources:</p>
                  <div className="flex flex-col sm:flex-row gap-3 justify-center text-sm">
                    <a
                      href="https://mcdonline.nic.in/portal/zones"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white hover:text-warm-amber transition-colors flex items-center justify-center"
                    >
                      <ExternalLink className="w-4 h-4 mr-1" />
                      Delhi MCD Zone Contact List
                    </a>
                    <span className="hidden sm:inline text-white/40">|</span>
                    <a
                      href="https://awbi.gov.in/uploads/documents/175388205383List%20of%20AWOs%20Municipal%20Corporations%20Granted%20Project%20Recognition.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white hover:text-warm-amber transition-colors flex items-center justify-center"
                    >
                      <ExternalLink className="w-4 h-4 mr-1" />
                      AWBI Approved ABC Centers
                    </a>
                  </div>
                </div>

                {/* Disclaimer */}
                <div className="mt-6 pt-6 border-t border-white/20">
                  <p className="text-xs text-white/70 text-center italic">
                    Disclaimer: We are not responsible for the validity, accuracy, or completeness of the information shared here. Use at your own discretion.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Emergency Numbers */}
      {/* <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <Card className="border-none shadow-2xl bg-forest-green text-white">
              <CardContent className="p-12 text-center">
                <Clock className="w-16 h-16 mx-auto mb-6" />
                <h2 className="text-4xl font-bold font-heading mb-4">24/7 Emergency Helpline</h2>
                <p className="text-xl mb-8">Our rescue team is always ready to respond</p>
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                    <Phone className="w-8 h-8 mx-auto mb-3" />
                    <p className="text-sm mb-2">Emergency Hotline</p>
                    <a href="tel:+919315982650" className="text-3xl font-bold hover:text-warm-amber transition-colors">
                      +91 9315982650
                    </a>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                    <MapPin className="w-8 h-8 mx-auto mb-3" />
                    <p className="text-sm mb-2">Main Office</p>
                    <p className="text-lg font-semibold">80/59B Basement, Malviya Nagar</p>
                    <p className="text-sm">New Delhi-110017</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default EmergencyRescue;